import { useIdentityVerification } from './useIdentityVerification'
import {
    TestPaymentImage,
    TestPaymentLearnMoreWrapper,
    useTestPaymentInfoDialog,
} from '../bills/useTestPaymentInfoDialog'
import { useNavigate } from 'react-router-dom'
import { Column } from '../../components/Layout/Column'
import { Body, Button, Spacer } from '@spritz-finance/ui'
import { TestPaymentGradientText } from '../../components/TestPaymentGradientText'
import React from 'react'

export const InitiateVerificationCard = () => {
    const { isActive } = useIdentityVerification()
    const { openDialog } = useTestPaymentInfoDialog()
    const navigate = useNavigate()

    const actionText = isActive ? 'Continue identity verification' : 'Verify your identity'
    return (
        <Column align="center">
            <TestPaymentImage />
            <Spacer height={16} />
            <Body.SmBold size={18} align="center">
                <TestPaymentGradientText>Get up to $10</TestPaymentGradientText>
                towards your first payment on
                <TestPaymentGradientText>every bill!</TestPaymentGradientText>
            </Body.SmBold>
            <Spacer height={16} />
            <Body.Med size={14} align="center">
                Take your first sip of Spritz! Make your first payment and we'll match it up to $10
                for each new bill added within 7 days of passing identity verification. &nbsp;
                <TestPaymentLearnMoreWrapper onClick={openDialog}>
                    Learn more.
                </TestPaymentLearnMoreWrapper>
                &nbsp; To add your first bill, complete a quick identity verification.
            </Body.Med>
            <Spacer height={32} />
            <Button.CTA onClick={() => navigate('/verification')}>{actionText}</Button.CTA>
        </Column>
    )
}
